export function removeStartingSlash(string?: string | null): string {
  const str = string ?? ''

  if (str?.startsWith('/')) {
    return str.replace('/', '')
  }

  return str
}
